import { FC } from 'react';
import type { DashboardPreset } from '@/entities/dashboards';
import type { IndicatorSelectHandler } from '../../model/useIndicatorTransitions';
import { CHART_CARD_CLASS, CHART_GRID_CLASS, chartCellClass, chartCellStyle } from './chartLayout';
import { CustomChartCard, type CustomChartPanelFilters } from './CustomChartCard';

type Props = {
  preset: DashboardPreset;
  /** Фильтры панели страницы — общие для всех диаграмм пресета */
  filters: CustomChartPanelFilters;
  onSelect: IndicatorSelectHandler;
  onOpenConversation: (conversationId: number, openInNewTab: boolean) => void;
};

/**
 * Сетка диаграмм применённого дашборда-пресета: порядок задан составом пресета,
 * ширина и высота каждой диаграммы — её размером, а начало строки — её признаком.
 */
export const DashboardPresetGrid: FC<Props> = ({ preset, filters, onSelect, onOpenConversation }) => (
  <div className={CHART_GRID_CLASS}>
    {preset.charts.map((chart) => (
      <div key={chart.id} className={chartCellClass(chart.size, chart.startsRow)} style={chartCellStyle(chart.height)}>
        <div className={CHART_CARD_CLASS}>
          <CustomChartCard
            chart={chart}
            filters={filters}
            onSelect={onSelect}
            onOpenConversation={onOpenConversation}
          />
        </div>
      </div>
    ))}
  </div>
);
